import {
    addWishlistItem,
    openWaitlistModal,
	PUB_SUB_EVENTS,
} from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import {
	addItemsToCart,
	getDOMCartSectionApiIds,
	renderResponseToCartDrawer
} from '@/scripts/core/cart-functions';
import { publish } from '@/scripts/core/global'

export class CartDrawerCollectionForm extends UcoastEl {
    static selectors = {
        toggle: '.cart-drawer-collection__toggle',
        form: 'form',
        variantPickerContainer: '.cart-drawer__variant-picker',
        atcButton: '.add-to-cart',
        selectedValue: '[data-selected-value]',
        select: '.cart-drawer-collection__select',
        sizeProperty: '[name="Size"]',
        sizeRadio: '.cart-drawer-size__input',
        error: '.cart-drawer-collection__item-error'
	}

    toggle: HTMLButtonElement
    form: HTMLFormElement
    variantPickerContainer: HTMLElement
    atcButton: HTMLButtonElement
    error: HTMLElement
    selectedValue?: HTMLSpanElement
    select?: HTMLSelectElement
    sizeProperty?: HTMLInputElement
    sizeRadios?: NodeListOf<HTMLInputElement>
    wkButtons?: NodeListOf<HTMLElement>
    static htmlSelector = 'cart-drawer-collection-form'
    constructor() {
        super()

        this.toggle = q.rs(CartDrawerCollectionForm.selectors.toggle, this)
        this.form = q.rs(CartDrawerCollectionForm.selectors.form, this)
        this.variantPickerContainer = q.rs(CartDrawerCollectionForm.selectors.variantPickerContainer, this)
        this.atcButton = q.rs(CartDrawerCollectionForm.selectors.atcButton, this)
        this.error = q.rs(CartDrawerCollectionForm.selectors.error, this)
        this.selectedValue = q.rs(CartDrawerCollectionForm.selectors.selectedValue, this)
        this.select = q.rs(CartDrawerCollectionForm.selectors.select, this)
        this.sizeProperty = q.rs(CartDrawerCollectionForm.selectors.sizeProperty, this)
        this.sizeRadios = this.querySelectorAll(CartDrawerCollectionForm.selectors.sizeRadio)

        this.toggle.addEventListener('click', this.toggleVariantPicker.bind(this))
        this.atcButton.addEventListener('click', this.onSubmit.bind(this))
        this.select?.addEventListener('change', this.onChangeSelect.bind(this))
        this.sizeRadios.forEach(radio => {
            radio.addEventListener('change', this.onChangeRadio.bind(this))
        })
    }

    toggleVariantPicker() {
        this.toggle.classList.add('hidden')
        this.variantPickerContainer.classList.remove('hidden')
        this.onChangeVariant()
    }

    onChangeVariant() {
        this.wkButtons = this.querySelectorAll('wishlist-button-collection')
        const selectedInput = this.querySelector('.cart-drawer-size__input:checked') as HTMLInputElement
        if(!selectedInput) return
        const inventoryStatus = q.oa(selectedInput, 'data-status')
        const variantId = q.oa(selectedInput, 'data-variant-id')
        this.atcButton.classList.toggle('hidden', inventoryStatus == 'ComingSoon')
        this.wkButtons?.forEach(wkButton => {
            if(q.oa(wkButton, 'data-variant-id') == variantId && inventoryStatus == 'ComingSoon') {
                wkButton.classList.remove('hidden')
            }
            else {
                wkButton.classList.add('hidden')
            }
        })
    }

    onChangeRadio(e: Event) {
        const size = (e.target as HTMLInputElement).value
        const status = (e.target as HTMLInputElement).dataset.status? (e.target as HTMLInputElement).dataset.status : ''
        const statusText = (e.target as HTMLInputElement).dataset.statusText? (e.target as HTMLInputElement).dataset.statusText : ''
        const variantId = (e.target as HTMLInputElement).dataset.variantId? (e.target as HTMLInputElement).dataset.variantId : ''
        const productId = (e.target as HTMLInputElement).dataset.productId? (e.target as HTMLInputElement).dataset.productId : ''
        this.atcButton.textContent = String(statusText)
        this.atcButton.setAttribute('data-status', String(status))
        if(status == 'OutOfStock') {
            this.atcButton.setAttribute('data-oos-popup-trigger', String(variantId))
        } else {
            this.atcButton.removeAttribute('data-oos-popup-trigger')
        }

        if(status == 'ComingSoon') {
            this.atcButton.setAttribute('data-product-id', String(productId))
            this.atcButton.setAttribute('data-variant-id', String(variantId))
        } else {
            this.atcButton.removeAttribute('data-product-id')
            this.atcButton.removeAttribute('data-variant-id')
        }
        if(this.select && this.select.querySelector(`option[data-size="${size}"]`)) {
            this.select.querySelector(`option[data-size="${size}"]`).selected = true
            this.onChangeSelect()
        }
        this.onChangeVariant()
    }

    onChangeSelect() {
        const selectedOption = this.select?.options[this.select.selectedIndex]
        if(selectedOption && this.selectedValue) {
            this.selectedValue.textContent = selectedOption.textContent?.trim() ?? ''
            if(this.sizeProperty) {
                this.sizeProperty.value = selectedOption.textContent?.trim() ?? ''
            }
        }
    }

    onSubmit(event: Event) {
        event.preventDefault()

        const oosId = q.oa(this.atcButton, 'data-oos-popup-trigger')
        const productTitle = q.oa(this.atcButton, 'data-title')
        if (oosId && productTitle) {
            openWaitlistModal(parseInt(oosId), productTitle.toString(), this.atcButton)
            return
        }

        const formData = new FormData(this.form)
        const filteredFormData = new FormData();
        for (const [key, value] of formData.entries()) {
            if (!key.includes('--size')) {
                filteredFormData.append(key, value)
            }
        }
        if(this.atcButton.dataset.status == 'PreOrder') formData.append('preorder', 'true')
        let formVariantId = filteredFormData.get('id')
		if (!formVariantId) throw Error('No variant id found')
		const addedVariantId = parseInt(formVariantId.toString())
        addItemsToCart(filteredFormData, getDOMCartSectionApiIds())
        .then((cart) => {
            if(cart.errors) {
                this.error.textContent = cart.errors
                return
            }

            this.error.textContent = ''

            publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: addedVariantId,
            })
            renderResponseToCartDrawer(cart)
        })
        .catch((e) => {
            console.error(e)
        })
        .finally(() => {
        })
    }
}